import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const LINKS = [
  { to: '/', label: 'Home', end: true },
  { to: '/analyze', label: 'Analyse' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/guides', label: 'Guides' },
  { to: '/history', label: 'My Reports' },
];

export default function SiteNav({ proActive, historyCount }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onAnalyze = location.pathname === '/analyze';

  return (
    <header className="site-nav">
      <div className="site-nav-inner">
        <Link to="/" className="site-nav-brand" onClick={() => setOpen(false)}>
          <img src="/logo.png" alt="" className="site-nav-logo" />
          <span className="site-nav-name">Prop Doc</span>
        </Link>

        <nav className={`site-nav-links ${open ? 'site-nav-links-open' : ''}`} aria-label="Main">
          {LINKS.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) => `site-nav-link ${isActive ? 'site-nav-link-active' : ''}`}
              onClick={() => setOpen(false)}
            >
              {l.label}
              {l.to === '/history' && historyCount > 0 && (
                <span className="site-nav-count">{historyCount}</span>
              )}
            </NavLink>
          ))}
          {!proActive && (
            <NavLink
              to="/signin"
              className={({ isActive }) => `site-nav-link ${isActive ? 'site-nav-link-active' : ''}`}
              onClick={() => setOpen(false)}
            >
              Sign in
            </NavLink>
          )}
        </nav>

        <div className="site-nav-actions">
          {proActive && (
            <span className="site-nav-pro" title="Pro plan active">
              <span className="site-nav-pro-dot" />
              Pro
            </span>
          )}
          {!onAnalyze && (
            <Link to="/analyze" className="btn-nav-cta">
              Analyse a document
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
            </Link>
          )}
          <button
            className="site-nav-burger"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            onClick={() => setOpen(o => !o)}
          >
            {open ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
